import { css } from 'styled-components';

const BUSINESS_CLOSED_BG = 'rgba(0, 0, 0, 0.06)';
const HOLIDAY_PAY_BG = 'rgba(219, 59, 80, 0.06)';
const IS_TODAY_BG = 'rgba(255, 255, 255, 0.5)';

export type ScheduleCellBgProps = {
  isToday?: boolean;
  isBusinessClosed?: boolean;
  isHolidayPay?: boolean;
};

const getBgColor = ({ isBusinessClosed, isHolidayPay, isToday }: ScheduleCellBgProps): string => {
  if (isBusinessClosed) {
    return BUSINESS_CLOSED_BG;
  }

  if (isHolidayPay) {
    return HOLIDAY_PAY_BG;
  }

  if (isToday) {
    return IS_TODAY_BG;
  }

  return 'transparent';
};

export default css<ScheduleCellBgProps>`
  background: ${(props): string => getBgColor(props)};
`;
